import React, { Fragment } from 'react';
import {StyleSheet, Text, View, ScrollView} from "react-native";
import OpenUrlButton from "./OpenUrlButton";
import {connect} from "react-redux";
import {useMarkdown, Renderer} from "./custom_markdown_processor";

class CustomRenderer extends Renderer {
  link(children, href, styles) {
    if (!href.startsWith("http") && !href.startsWith(window.location.hostname)) {
      href = "https://" + href;
      return <OpenUrlButton key={this.getKey()} url={href} title={children} style={styles} />
    }
    return <OpenUrlButton key={this.getKey()} url={href} title={children} style={styles} />
    // return Renderer.prototype.link.call(this, children, href, styles);
  }
}

const renderer = new CustomRenderer();

const MarkdownElement = ({ isDark, theme, text }) => {
  const theme_mode = isDark ? "dark" : "light";

  const options = {
    colorScheme: theme_mode,
    renderer: renderer
  }

  const elements = useMarkdown(text, options);

  return <ScrollView>
    {elements.map((element, index) => {
      return <Fragment key={`demo_${index}`}>{element}</Fragment>
    })}
  </ScrollView>
}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(MarkdownElement);
